import { Box, FormControl } from '@mui/material';
import { DriverType } from '../../../interfaces/delivery-company/drivers';
import AutocompleteWithThrottle from '../autocomplete-with-throttle/autocomplete-with-throttle';
import { useDrivers } from '../../../hooks/use-drivers';

interface DriverSelectorProps {
  selectedDriver: DriverType | null;
  onSelect: (driver: DriverType | null) => void;
  label?: string;
  required?: boolean;
  disabled?: boolean;
  placeholder?: string;
  excludeDeleted?: boolean;
  compact?: boolean;
}

/**
 * DriverSelector component using AutocompleteWithThrottle
 * Allows users to search and select a driver by name or phone number
 */
export const DriverSelector = ({
  selectedDriver,
  onSelect,
  label = 'Driver',
  required = false,
  disabled = false,
  placeholder,
  excludeDeleted = true,
  compact = false,
}: DriverSelectorProps) => {
  const { fetchDrivers } = useDrivers({ excludeDeleted });

  return (
    <Box sx={compact ? { width: '100%', maxWidth: '100%' } : { width: '100%' }}>
      <FormControl fullWidth size={compact ? 'small' : 'medium'}>
        <AutocompleteWithThrottle<DriverType>
          label={label}
          required={required}
          fetch={fetchDrivers}
          value={selectedDriver}
          getOptionLabel={(option: DriverType) =>
            `${option.name} ${option.phone_number}${option.is_deleted ? ' (Deactivated)' : ''}`
          }
          isOptionEqualToValue={(option, value) => option.id === value.id}
          onChange={(e, value) => {
            onSelect(value);
          }}
          fetchAllOnLoad
          disabled={disabled}
          placeholder={placeholder}
          size={compact ? 'small' : 'medium'}
          disablePortal={!compact}
        />
      </FormControl>
    </Box>
  );
};

